import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { HistorialNotificacion } from 'src/app/models/notificacion/historial_notificacion.model';
import { Lista } from 'src/app/pages/base/lista';
import { HistorialNotificacionService } from 'src/app/services/notificacion/historial_notificacion.service';

@Component({
  selector: 'app-historial-notificacion-lista',
  templateUrl: './historial-notificacion-lista.component.html',
  styleUrls: ['./historial-notificacion-lista.component.scss']
})
export class HistorialNotificacionListaComponent extends Lista implements OnInit {

    constructor(
        public router: Router,
        public messageService: MessageService,
        public service: HistorialNotificacionService,
        private breadcrumbService: AppBreadcrumbService,
    ) {
        super(router, messageService, service, HistorialNotificacion.CODIGO_MODULO, HistorialNotificacion.CODIGO_REGISTRO);
        this.breadcrumbService.setItems([{ label: 'Notificacion' }, { label: 'Historial de Notificaciones' }]);
        this.recordName = HistorialNotificacion.RECORD_NAME;
        this.name = HistorialNotificacion.NOMBRE_SINGULAR;
        this.pluralName = HistorialNotificacion.NOMBRE_PLURAL;
        this.navigate = [this.prefixPage, this.modulo, 'historial-notificaciones'];
        this.columns = [
            { field: 'nombre_empresa', label: 'Empresa', type: 'text', hidden: !this.currentUser.superusuario },
            { field: 'id', label: 'Id', type: 'id' },
            { field: 'fecha', label: 'Fecha', type: 'datetime' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'descripcion', label: 'Descripcion', type: 'text' },
            // { field: 'archivo', label: 'Archivo', type: 'text' },
            { field: 'total_enviado', label: 'Total Enviado', type: 'number' },
            // Estado real del envio, que no vive en historial_notificaciones sino
            // en el job. Sin esto una campania interrumpida se ve igual que una
            // completa y nadie se entera hasta que llama un cliente.
            { field: 'estado_envio_resumen', label: 'Envio', type: 'text' },
            { field: 'tipo', label: 'Tipo', type: 'multiselect', options: HistorialNotificacion.TIPOS },
            { field: 'activo', label: 'Activo', type: 'boolean' },
        ]
    }

    ngOnInit(): void {
    }

}
